import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Col, Button } from 'react-bootstrap'
import {
  IoIosEye as VisibilityOn,
  IoIosEyeOff as VisibilityOff,
} from 'react-icons/io'
import { merchProductContainer } from 'src/models'
import { AccordionBlock } from 'src/views/components'
import { handleFilterCbk } from 'src/deps'
import isMerchPLP, { filtersOpenByDefault, APPConfig } from 'config/appConfig'
import {
  IS_BROWSER,
  application,
  trackFilter,
  i18nTranslate,
  enablePlpRedesign,
  rememberFocusTarget,
  trackFocusWithin,
  restoreFocusAfterRemount,
} from 'src/utils'
import { checkIsNativeApp } from 'src/utils/reactNativeAppUtils'
import { ListView } from '../ListView'
import { MobileFilterHeader } from '../MobileFilterHeader'
import { PriceFilterSlider } from './PriceFilterSlider/PriceFilterSlider'
import './styles.scss'

@observer
class SideFilter extends React.Component {
  nameSpace = 'ssr-resource'
  @observable filterList = []
  @observable selectedFacet = {
    id: '',
    isActive: '',
  }
  @observable selectedFilter = this.props?.filterProps
    ? JSON.parse(this.props?.filterProps || '{}').filters
    : []

  constructor(props) {
    super(props)
    this.filterList = props?.facetFilter || []
  }

  handleReset = () => {
    if (isMerchPLP) {
      // console.log('saveData test', merchProductContainer.handleSaveAction())
      // parent.postMessage(
      //   merchProductContainer.handleSaveAction(),
      //   'http://localhost:8080'
      // )
    } else {
      this.selectedFilter = []
      this.props?.handleFilter()
    }
  }

  componentDidUpdate = prevProps => {
    const { facetFilter } = this.props
    this.filterList = facetFilter
    const isDifferentCategory =
      prevProps?.location?.pathname !== this.props?.location?.pathname
    if (isDifferentCategory) {
      this.selectedFilter = []
    }
    try {
      if (prevProps?.filterProps !== this.props?.filterProps) {
        if (!this.props?.filterProps) {
          this.selectedFilter = []
        } else {
          this.selectedFilter = this.props?.filterProps
            ? JSON.parse(this.props.filterProps).filters
            : []
        }
      }
    } catch (e) {
      console.error('JSON.parse may be an error >>> ', e)
    }
  }

  componentDidMount = () => {
    this.filterList?.forEach((item, index) => {
      this.filterList[index].isVisible = item?.values?.some(
        value => value?.selected === true
      )
    })

    merchProductContainer.setFacetPositions(this.filterList)

    if (IS_BROWSER) {
      trackFocusWithin('.drag-facet-list')
      this.focusRestoreTimer = restoreFocusAfterRemount()
    }
  }
  componentWillUnmount() {
    clearTimeout(this.focusRestoreTimer)
  }

  handleClick = (name, value, event) => {
    if (event?.key === 'Enter') {
      const activeFilterId = document.activeElement?.id
      if (activeFilterId) {
        rememberFocusTarget(activeFilterId)
      }
    }

    if (!isMerchPLP) {
      trackFilter({
        filterKey: name,
        filterValue: value,
        facetFilter: this.props?.facetFilter,
      })
      if (enablePlpRedesign() && application?.isMobile) {
        this.selectedFilter =
          handleFilterCbk({
            props: { ...this.props },
            nameValue: { name, value },
            makeApi: false,
            selectedFilter: this.selectedFilter,
          }) ?? []
      } else {
        handleFilterCbk({
          props: { ...this.props },
          nameValue: { name, value },
        })
      }
    }
  }

  // handleFilterArrangement = result => {
  //   let sourceIndex = result?.source?.index || 0
  //   let destinationIndex = result?.destination?.index || 0
  //   const sourceData = this.filterList[sourceIndex]
  //   while (destinationIndex !== sourceIndex) {
  //     if (sourceIndex > destinationIndex) {
  //       this.filterList[sourceIndex] = this.filterList[sourceIndex - 1]
  //       sourceIndex = sourceIndex - 1
  //     } else {
  //       this.filterList[sourceIndex] = this.filterList[sourceIndex + 1]
  //       sourceIndex = sourceIndex + 1
  //     }
  //   }
  //   this.filterList[destinationIndex] = sourceData
  //   console.log('facet postions', this.filterList)
  //   merchProductContainer.setFacetPositions(this.filterList)
  // }

  // onDragEnd = async result => {
  //   // dropped outside the list
  //   if (!result.destination) {
  //     return
  //   }
  //   console.log('drag and drop final result', result)
  //   this.handleFilterArrangement(result)
  // }

  renderIcon = isOpen => {
    if (filtersOpenByDefault && !isMerchPLP) {
      return <></>
    } else {
      return isOpen ? <VisibilityOff /> : <VisibilityOn />
    }
  }

  renderActiveFilter = item => {
    if (item && item.isVisible !== '' && item.isVisible !== undefined) {
      return item.isVisible
    } else if (
      filtersOpenByDefault === true &&
      application?.isTabletOrLarger &&
      !isMerchPLP
    ) {
      return true
    } else if (!application.isTabletOrLarger) {
      return false
    } else {
      return isMerchPLP
    }
  }

  handleVisibilityToggle = params => {
    const { selectedFacet, isOpen, uniqueKey } = params
    this.selectedFacet = {
      facetId: selectedFacet,
      visible: isOpen,
    }

    this.filterList.forEach((item, index) => {
      if (`filter_accordion_${item?.key}` === uniqueKey) {
        this.filterList[index].isVisible = this.selectedFacet?.visible

        if (isOpen) {
          rememberFocusTarget(`filter_accordion_${item?.key}`)
        }
      }
    })

    merchProductContainer?.setFacetPositions(this.filterList)
  }

  isFilterChecked = (name, keyName) => {
    const filterKey = this.selectedFilter?.find(
      filter => filter.field === keyName
    )
    const filters = filterKey && filterKey?.value?.trim()?.split(',')
    if (filterKey && filters.includes(name)) {
      return true
    }
    return false
  }

  renderCheckboxBasedFilters = item => {
    return (
      <ol
        className="facet-list p-0 m-0 pt-3"
        id={`filter_accordion_${item?.key}`}
        key={`filter_accordion_${item?.key}`}
        uniqueKey={`filter_accordion_${item?.key}`}>
        <li>
          <fieldset>
            <ListView
              filterKey={item?.key}
              item={item}
              className="check-box-wrap mb-2 text-break"
              handleClick={this.handleClick}
              isFilterChecked={this.isFilterChecked}
              currencySymbol={this.props.currencySymbol ?? '$'}
              focusId={`filter_${item?.key}`}
            />
          </fieldset>
        </li>
      </ol>
    )
  }

  renderFilterItems = (item, index = 0) => {
    const isActive = this.renderActiveFilter(item)
    const shouldShowPriceSliderFilter =
      APPConfig?.getAppConfig()?.shouldShowPriceSliderFilter &&
      APPConfig?.getAppConfig()?.shouldShowPriceSliderFilter === 'true'

    const isOldPriceNodeForCheckbox =
      (item?.key?.toLowerCase() == 'range_facet_price' &&
        item?.name?.toLowerCase() == 'price') ||
      (item?.key?.toLowerCase() == 'range_facet_wholesaleprice' &&
        item?.name?.toLowerCase() == 'price')

    const isNewPriceNodeForSlider =
      (item?.key?.toLowerCase() == 'range_facet_price' &&
        item?.name?.toLowerCase() == 'facet_price') ||
      (item?.key?.toLowerCase() == 'range_facet_wholesaleprice' &&
        item?.name?.toLowerCase() == 'facet_wholesaleprice')
    // changes made as per Poovarasan's input

    const isToHideUnwantedPriceSection =
      (isOldPriceNodeForCheckbox && shouldShowPriceSliderFilter) ||
      (isNewPriceNodeForSlider && !shouldShowPriceSliderFilter)
    // ^ for hiding old data while showing slider
    // ^ and for hiding new data while showing old checkboxes

    const isToShowPriceSlider =
      isNewPriceNodeForSlider && shouldShowPriceSliderFilter

    const title =
      isOldPriceNodeForCheckbox || isNewPriceNodeForSlider
        ? i18nTranslate('plp.price', 'price', { nameSpace: this.nameSpace })
        : item?.name
    // ^ backend team (poovarasan) asked to translate price label in frontend
    if (
      item?.key.toLowerCase().replace(/\s/, '').match('categoryidmapping') ||
      !item?.name ||
      (item?.name === 'price' && item?.values?.length == 0) ||
      isToHideUnwantedPriceSection
    ) {
      return <></>
    }

    return (
      <div
        className="drag-facet-list"
        dataTestId={`qa-plp-filter-by-${item?.key}`}
        id={`filter_accordion_${item?.key}`}>
        {item?.name && (
          <AccordionBlock
            id={`filter_accordion_${item?.key}`}
            key={`filter_accordion_${item?.key}`}
            uniqueKey={`filter_accordion_${item?.key}`}
            // this key is used for accordion open close logic
            // please don't change
            className={`filter-facet border-bottom border-light-grey plp-side-filter ${
              isToShowPriceSlider
                ? 'price-slider-accordion-wrapper'
                : 'checkbox-accordion-wrapper'
            }`}
            dataTestId="qa-plp-filter"
            title={title}
            // onClick={this.handleAccordionOpenClick}
            renderIcon={
              (isMerchPLP ||
                (filtersOpenByDefault && application?.isTabletOrLarger)) &&
              this.renderIcon
            }
            isActive={
              !application?.isMobile ||
              (application?.isMobile && enablePlpRedesign())
                ? true
                : title === this.selectedFacet?.facetId &&
                  this.selectedFacet?.visible
            }
            isMerchPLP={isMerchPLP}
            onClick={this.handleVisibilityToggle}
            index={index}>
            {isToShowPriceSlider ? (
              <>
                <PriceFilterSlider
                  item={item}
                  onSliderChange={this.handleClick}
                  {...this.props}></PriceFilterSlider>
                {/* {this.renderCheckboxBasedFilters(item)} */}
              </>
            ) : (
              this.renderCheckboxBasedFilters(item)
            )}
          </AccordionBlock>
        )}
      </div>
    )

    // return (
    //   <Draggable
    //     key={item?.key}
    //     isDragDisabled={!isMerchPLP}
    //     draggableId={item?.key + index}
    //     disableInteractiveElementBlocking={true}
    //     index={index}>
    //     {provided => (
    //       <div
    //         className="drag-facet-list"
    //         ref={provided.innerRef}
    //         {...provided.draggableProps}
    //         {...provided.dragHandleProps}>
    //         {item?.name && (
    //           <AccordionBlock
    //             key={`filter-accordion_${index}`}
    //             className="filter-facet border-bottom border-light-grey plp-side-filter"
    //             dataTestId="qa-plp-filter"
    //             title={filterName}
    //             // onClick={this.handleAccordionOpenClick}
    //             renderIcon={
    //               (isMerchPLP ||
    //                 (filtersOpenByDefault && application?.isTabletOrLarger)) &&
    //               this.renderIcon
    //             }
    //             isActive={isActive}
    //             isMerchPLP={isMerchPLP}
    //             onClick={this.handleVisibilityToggle}
    //             index={index}>
    //             <ol className="facet-list p-0 m-0 pt-3">
    //               <fieldset>
    //                 <ListView
    //                   filterKey={item?.key}
    //                   item={item}
    //                   className="check-box-wrap mb-2 text-break"
    //                   handleClick={this.handleClick}
    //                   currencySymbol={this.props.currencySymbol || '$'}
    //                 />
    //               </fieldset>
    //             </ol>
    //           </AccordionBlock>
    //         )}
    //       </div>
    //     )}
    //   </Draggable>
    // )
  }

  renderFilterTitle = () => {
    const { toggleFilter, isFilterOpen = false } = this.props
    return (
      <MobileFilterHeader
        toggleFilter={toggleFilter}
        handleReset={this.handleReset}
        isDragFacetListFilterOpen={isFilterOpen}
      />
    )
  }

  handleFilterApply = () => {
    if (!isMerchPLP) {
      this.props.handleFilter(this.selectedFilter ?? [])
    }
  }

  render() {
    const shouldShowMobileApplyCancelButtons =
      enablePlpRedesign() && application?.isMobile && !checkIsNativeApp()

    const facetView =
      this.filterList &&
      this.filterList
        .filter(item => item?.key !== 'facet_specification')
        .map(this.renderFilterItems)

    const sideFilterColClassNames = `side-filter-wrapper ${
      (!this.props.isFilterOpen && !application.isTabletOrLarger) || !IS_BROWSER
        ? 'd-none'
        : 'd-block'
    }`

    const { toggleFilter } = this.props

    return (
      <Col lg={3} md={3} className={sideFilterColClassNames}>
        {enablePlpRedesign() && application?.isMobile && (
          <div
            className="filter-outer-touch"
            onClick={() => {
              toggleFilter()
            }}></div>
        )}
        <div className="filter-wrapper bg-white pt-2 mt-2">
          {!isMerchPLP && this.renderFilterTitle()}
          {shouldShowMobileApplyCancelButtons ? (
            <>
              <div className="plp-filter-facet-container">{facetView}</div>
              <div
                className={`plp-side-filter-btn-container ${enablePlpRedesign() ? 'flex-column-reverse' : ''}`}>
                <Button
                  className="plp-side-filter-btn d-flex cta cancel"
                  onClick={() => {
                    toggleFilter()
                  }}
                  data-testid="qa-mobile-filter-cancel-button">
                  {i18nTranslate('generic.cancel', 'Cancel', {
                    nameSpace: 'ssr-resource',
                  })}
                </Button>
                <Button
                  className="plp-side-filter-btn d-flex cta apply"
                  onClick={() => {
                    this.handleFilterApply(this.props)
                  }}
                  data-testid="qa-mobile-filter-apply-button">
                  {i18nTranslate('cartStrings.apply', 'Apply', {
                    nameSpace: 'ssr-resource',
                  })}
                </Button>
              </div>
            </>
          ) : (
            facetView
          )}
        </div>
      </Col>
    )

    // return (
    //   <Col
    //     lg={3}
    //     md={3}
    //     className={sideFilterColClassNames}>
    //     <DragDropContext onDragEnd={this.onDragEnd}>
    //       <Droppable isDropDisabled={false} droppableId="droppable">
    //         {provided => (
    //           <div
    //             {...provided.droppableProps}
    //             ref={provided.innerRef}
    //             className="filter-wrapper bg-white px-2 pt-2 mt-2">
    //             {!isMerchPLP && this.renderFilterTitle()}
    //             {facetView}
    //           </div>
    //         )}
    //       </Droppable>
    //     </DragDropContext>
    //   </Col>
    // )
  }
}

export { SideFilter }
export default SideFilter
